module.exports = __webpack_public_path__ + "static/img/stl2.39ae621.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/stl2.png
// module id = N/s1
// module chunks = 1